import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaPrimary, CtaGhost } from "@/components/CTA";
import { MaskLines, TechLabel, Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/site";

export function PageHeader({ crumbs, eyebrow, titleLines, intro }) {
  return (
    <section className="relative pt-36 pb-16 lg:pt-44 lg:pb-24 border-b border-offwhite/10 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative max-w-[1600px] mx-auto px-6 lg:px-10">
        <Breadcrumbs items={crumbs} />
        <div className="mt-10">
          <TechLabel>{eyebrow}</TechLabel>
        </div>
        <h1 className="font-display font-black uppercase tracking-tight text-offwhite text-[clamp(2.4rem,9vw,3rem)] md:text-7xl lg:text-8xl leading-[0.94] md:leading-[0.92] mt-6 break-words">
          <MaskLines lines={titleLines} />
        </h1>
        {intro && (
          <Reveal delay={0.3}>
            <p className="text-mutedgray text-lg md:text-xl max-w-2xl mt-8 leading-relaxed">{intro}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}

const CTA_BG = "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/k0oaq98t_underground-mine-workers-looking-at-a-huge-mining-truck-free-photo.jpeg";

export function CTASection({ title = "READY WHEN A MACHINE IS DOWN.", copy = "Send us the part number, brand or machine model. We respond with origin, lead time and pricing." }) {
  return (
    <section className="relative overflow-hidden border-t border-offwhite/10" data-testid="cta-section">
      {/* Background image */}
      <img src={CTA_BG} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover" />
      {/* Darkening overlay for legibility */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(8,8,6,0.86) 0%, rgba(8,8,6,0.6) 45%, rgba(8,8,6,0.3) 100%)" }} />
      {/* Bottom fade into page background */}
      <div className="absolute inset-x-0 bottom-0 h-40" style={{ background: "linear-gradient(to bottom, transparent, #FAFAF8)" }} />

      <div className="relative max-w-[1600px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
        <div className="max-w-3xl">
          <TechLabel color="#D9B27C">Request a Quote</TechLabel>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-4xl md:text-6xl leading-[0.95] mt-6 drop-shadow-lg">
            <Reveal>{title}</Reveal>
          </h2>
          <Reveal delay={0.15}>
            <p className="text-white/80 text-lg max-w-xl mt-6 leading-relaxed">{copy}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="flex flex-wrap gap-4 mt-10">
              <Link
                to="/quote"
                data-testid="cta-section-quote"
                className="inline-flex items-center gap-3 px-8 py-4 font-mono-tech text-xs uppercase tracking-[0.2em] bg-white text-[#111212] hover:bg-[#EDEAE2] transition-colors"
              >
                Request a Quote <span aria-hidden>→</span>
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
